"use strict";

exports.__esModule = true;
exports.default = exports.colors = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _colors2 = _interopRequireDefault(require("../../constants/colors"));

var _spacing = _interopRequireDefault(require("../../constants/spacing"));

var _vars = _interopRequireDefault(require("../../constants/vars"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: inline-block;\n\tfont-family: 'galano-bold', 'galano', sans-serif;\n\tfont-weight: bold;\n\tcolor: #fff;\n\tbackground-color: ", ";\n\tpadding: 0 ", ";\n\tline-height: 1.5;\n\tborder-radius: ", ";\n\ttext-align: center;\n\tborder: 0;\n\t", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var colors = {
  primary: 'primary',
  secondary: 'secondary',
  grey: 'grey'
};
exports.colors = colors;

var Badge = _styledComponents.default.span(_templateObject(), function (props) {
  return _colors2.default[props.color];
}, _spacing.default.s1, _vars.default.borderRadius, function (props) {
  return props.onClick && 'cursor: pointer';
});

Badge.displayName = 'Badge';
Badge.defaultProps = {
  color: 'secondary'
};
Badge.propTypes = {
  color: (0, _propTypes.oneOf)(Object.keys(colors))
};

/* @component */
var _default = Badge;
exports.default = _default;